import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROUTES } from '../constants';
import '../styles/header.scss';

export const Header = () => {
  const [openMenu, setOpenMenu] = useState(true);
  const [mobileMenuTab, setMobileMenuTab] = useState(0);
  const basket = useSelector(state => state.basket.basket);
  const history = useHistory();

  const onBasketClick = e => !basket.length && e.preventDefault();

  const onToggleMobileMenu = () => setOpenMenu(open => !open);

  const onOpenSubmenu = event => {
    event.target.classList.toggle('active');
    const menu =
      event.target.parentNode.querySelector('.wd-sub-menu') || event.target.parentNode.querySelector('.sub-sub-menu');
    menu.classList.toggle('shown');
  };

  useEffect(() => {
    setOpenMenu(false);
  }, [history.location.pathname]);

  return (
    <header className="whb-header whb-default_header whb-sticky-shadow whb-scroll-stick whb-sticky-real whb-sticky-prepared">
      <div className="whb-main-header">
        <div className="whb-row whb-top-bar whb-not-sticky-row whb-with-bg whb-without-border whb-color-light whb-hidden-mobile whb-flex-flex-middle">
          <div className="container">
            <div className="whb-flex-row whb-top-bar-inner">
              <div className="whb-column whb-col-left whb-visible-lg">
                <div
                  className="wd-header-nav wd-header-secondary-nav text-left"
                  role="navigation"
                  aria-label="Secondary navigation"
                >
                  <ul className="menu wd-nav wd-nav-secondary wd-style-default wd-gap-s">
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-281 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/o-fotopochte/" className="woodmart-nav-link">
                        <span className="nav-link-text">О ФотоПочте</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-276 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/akczii/" className="woodmart-nav-link">
                        <span className="nav-link-text">Акции</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-280 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/sdelaem-za-vas/" className="woodmart-nav-link">
                        <span className="nav-link-text">Сделаем за вас</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-282 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/biznesu/" className="woodmart-nav-link">
                        <span className="nav-link-text">Бизнесу</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-762 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/reviews/" className="woodmart-nav-link">
                        <span className="nav-link-text">Отзывы</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-279 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/faq/" className="woodmart-nav-link">
                        <span className="nav-link-text">FAQ</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-278 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/franshiza/" className="woodmart-nav-link">
                        <span className="nav-link-text">Франшиза</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-277 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/podderzhka-i-kontakty/" className="woodmart-nav-link">
                        <span className="nav-link-text">Поддержка и контакты</span>
                      </a>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1279 item-level-0 menu-simple-dropdown wd-event-hover">
                      <a href="https://www.fotopostapp.ru/delivery/" className="woodmart-nav-link">
                        <span className="nav-link-text">Доставка</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="whb-row whb-general-header whb-sticky-row whb-without-bg whb-border-fullwidth whb-color-dark whb-flex-flex-middle">
          <div className="container">
            <div className="whb-flex-row whb-general-header-inner">
              <div className="whb-column whb-col-left whb-visible-lg">
                <div className="site-logo">
                  <a href="https://www.fotopostapp.ru/" className="wd-logo wd-main-logo">
                    <img
                      src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/logo.png"
                      alt="FotoPostApp"
                      style={{ maxWidth: '150px' }}
                    />
                  </a>
                </div>
              </div>
              <div className="whb-column whb-col-center whb-visible-lg">
                <Link to={ROUTES.BASKET} className="basket" onClick={onBasketClick}>
                  {!!basket.length && <div>{basket.length}</div>}
                </Link>
              </div>
              <div className="whb-column whb-col-center whb-visible-lg">
                <div className="info-box-wrapper  whb-jroqfypgzzoiouqh93dt">
                  <div className=" wd-info-box text-left box-icon-align-top box-style-base color-scheme- wd-bg-none ">
                    <a
                      className="wd-info-box-link"
                      aria-label="Infobox link"
                      href="https://www.facebook.com/fotopostapp.ru"
                      title=""
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path
                          d="M9.01265 0C4.03995 0 0 4.04641 0 9.02708C0 13.5485 3.32957 17.2903 7.66603 17.9428L8.13651 18.0141V10.9008H6.00737V9.45663H8.13651V7.53886C8.13651 6.35792 8.41944 5.58013 8.88783 5.09216C9.35622 4.60418 10.0483 4.35806 11.0114 4.35806C11.7815 4.35806 12.0811 4.4048 12.366 4.43981V5.62189H11.3634C10.7946 5.62189 10.3279 5.93978 10.0856 6.36319C9.84338 6.78661 9.76797 7.29216 9.76797 7.80733V9.45583H12.2764L12.0531 10.9H9.76797V18.0253L10.2328 17.962C14.6309 17.3646 18.0253 13.5927 18.0253 9.02708C18.0253 4.04641 13.9854 0 9.01265 0ZM9.01265 0.820643C13.5426 0.820643 17.206 4.48992 17.206 9.02708C17.206 13.0194 14.353 16.3028 10.5873 17.042V11.7206H12.7557L13.2317 8.63519H10.5873V7.80733C10.5873 7.38163 10.6651 7.00021 10.7961 6.77111C10.9272 6.54201 11.0536 6.44253 11.3634 6.44253H13.1853V3.6969L12.8301 3.64882C12.5844 3.61552 12.0234 3.53742 11.0114 3.53742C9.90401 3.53742 8.95348 3.83956 8.29734 4.52316C7.64119 5.20675 7.31718 6.22463 7.31718 7.53886V8.63599H5.18803V11.7214H7.31718V17.0163C3.61202 16.2302 0.819332 12.9762 0.819332 9.02708C0.819332 4.48992 4.48274 0.820643 9.01265 0.820643Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="info-box-wrapper  whb-jlawjv9ve56im9uqbb0r">
                  <div className=" wd-info-box text-left box-icon-align-top box-style-base color-scheme- wd-bg-none ">
                    <a
                      className="wd-info-box-link"
                      aria-label="Infobox link"
                      href="https://www.instagram.com/fotopostapp"
                      title=""
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                        <path
                          d="M5.35105 0C2.41476 0 0.0253906 2.38937 0.0253906 5.32566V12.6996C0.0253906 15.6359 2.41476 18.0253 5.35105 18.0253H12.725C15.6613 18.0253 18.0507 15.6359 18.0507 12.6996V5.32566C18.0507 2.38937 15.6613 0 12.725 0H5.35105ZM5.35105 0.819332H12.725C15.2185 0.819332 17.2314 2.83223 17.2314 5.32566V12.6996C17.2314 15.1931 15.2185 17.206 12.725 17.206H5.35105C2.85762 17.206 0.844723 15.1931 0.844723 12.6996V5.32566C0.844723 2.83223 2.85762 0.819332 5.35105 0.819332ZM13.954 3.27733C13.7367 3.27733 13.5283 3.36365 13.3747 3.5173C13.221 3.67096 13.1347 3.87936 13.1347 4.09666C13.1347 4.31396 13.221 4.52236 13.3747 4.67601C13.5283 4.82967 13.7367 4.91599 13.954 4.91599C14.1713 4.91599 14.3797 4.82967 14.5334 4.67601C14.687 4.52236 14.7734 4.31396 14.7734 4.09666C14.7734 3.87936 14.687 3.67096 14.5334 3.5173C14.3797 3.36365 14.1713 3.27733 13.954 3.27733ZM9.03804 4.50633C6.55412 4.50633 4.53172 6.52873 4.53172 9.01265C4.53172 11.4966 6.55412 13.519 9.03804 13.519C11.522 13.519 13.5444 11.4966 13.5444 9.01265C13.5444 6.52873 11.522 4.50633 9.03804 4.50633ZM9.03804 5.32566C11.0792 5.32566 12.725 6.97153 12.725 9.01265C12.725 11.0538 11.0792 12.6996 9.03804 12.6996C6.99692 12.6996 5.35105 11.0538 5.35105 9.01265C5.35105 6.97153 6.99692 5.32566 9.03804 5.32566Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="info-box-wrapper  whb-tvb1y0gly52vdvxtv5rv">
                  <div
                    id="wd-6628d842d05e0"
                    className=" wd-info-box text-left box-icon-align-top box-style-base color-scheme- wd-bg-none "
                  >
                    <a
                      className="wd-info-box-link"
                      aria-label="Infobox link"
                      href="https://vk.com/fotopostapp"
                      title=""
                    >
                      <svg
                        id="svg-2306"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <path
                          d="M9.06343 0C4.09052 0 0.0507812 4.03974 0.0507812 9.01265C0.0507812 13.9856 4.09052 18.0253 9.06343 18.0253C14.0363 18.0253 18.0761 13.9856 18.0761 9.01265C18.0761 4.03974 14.0363 0 9.06343 0ZM9.06343 0.783709C13.6128 0.783709 17.2924 4.46329 17.2924 9.01265C17.2924 13.562 13.6128 17.2416 9.06343 17.2416C4.51407 17.2416 0.83449 13.562 0.83449 9.01265C0.83449 4.46329 4.51407 0.783709 9.06343 0.783709ZM5.14565 6.26967L3.56446 6.27044C3.56446 6.27044 3.47398 6.26534 3.36471 6.27962C3.25543 6.2939 3.094 6.30053 2.92846 6.48779L2.9277 6.48856L2.92693 6.48932C2.77969 6.65771 2.7853 6.85369 2.80371 6.96154C2.82205 7.06898 2.86341 7.14981 2.86341 7.14981V7.15058C2.87861 7.18787 4.02668 10.0009 5.47398 11.5123C6.49486 12.579 7.58669 12.9312 8.55907 12.9312H9.06343C9.22937 12.9312 9.37756 12.9236 9.54177 12.8386C9.70598 12.7535 9.84714 12.5188 9.84714 12.3365C9.84714 12.1401 9.85196 11.9498 9.87699 11.8436C9.90036 11.7445 9.89134 11.7689 9.90071 11.7686C9.91011 11.7707 9.92721 11.7746 9.95965 11.7893C10.0295 11.8209 10.1376 11.8915 10.2574 11.9845C10.4966 12.1702 10.78 12.4396 11.0977 12.648C11.5528 12.9497 12.0467 12.9312 12.0467 12.9312H13.6754L13.693 12.9297C13.693 12.9297 13.9429 12.924 14.1996 12.7666C14.328 12.688 14.4806 12.5437 14.5318 12.3273C14.583 12.111 14.5176 11.8841 14.3917 11.6845C14.3457 11.6112 14.1225 11.2877 13.2315 10.4966C13.0013 10.2925 12.8443 10.148 12.7822 10.0711C12.7602 10.0438 12.7583 10.0465 12.7539 10.0451C12.7591 10.0317 12.8106 9.92328 12.9483 9.74432C13.0918 9.55779 13.31 9.2979 13.5904 8.94071C13.9479 8.4853 14.1987 8.0474 14.3565 7.6779C14.4354 7.49315 14.4914 7.3255 14.5249 7.17354C14.5584 7.02157 14.5852 6.89525 14.5356 6.7151C14.4987 6.58099 14.3983 6.46088 14.2999 6.39748C14.2015 6.33408 14.1098 6.3102 14.0274 6.29493C13.8628 6.26438 13.7175 6.26967 13.582 6.26967C13.2984 6.26967 12.0375 6.27962 11.9335 6.27962C11.8113 6.27962 11.6165 6.33049 11.5263 6.38217C11.3024 6.51037 11.2324 6.68602 11.2324 6.68602L11.211 6.72352L11.1987 6.76561C11.1987 6.76561 10.9116 7.69438 10.6163 8.17307H10.6155C10.2683 8.73699 10.0093 8.96068 9.89536 9.02413C9.88326 9.03087 9.88996 9.02729 9.88158 9.03178C9.87267 9.00584 9.86143 8.97011 9.85403 8.90397C9.83737 8.75498 9.84714 8.54516 9.84714 8.34221C9.84714 7.78013 9.88935 7.42963 9.84255 7.09777C9.81915 6.93184 9.75957 6.74705 9.62366 6.60489C9.48775 6.46273 9.31221 6.39275 9.1369 6.35233H9.13614C8.95344 6.31025 8.75656 6.27412 8.28355 6.26967C7.68088 6.26405 7.28838 6.28273 6.93961 6.43805L6.93579 6.44034L6.93272 6.44187C6.79492 6.5066 6.68629 6.5808 6.59062 6.67989C6.54278 6.72944 6.48603 6.76552 6.44673 6.92327C6.42708 7.00215 6.42493 7.15138 6.51408 7.27227C6.60324 7.39315 6.72818 7.42962 6.80185 7.43911C6.78826 7.43735 6.85981 7.45309 6.91512 7.48044C6.97044 7.50779 7.01846 7.54716 7.03069 7.5631V7.56386C7.02557 7.55722 7.07869 7.68922 7.09268 7.80954C7.10667 7.92985 7.10416 8.02689 7.10416 8.02689L7.10339 8.05062L7.10569 8.07434C7.10569 8.07434 7.12975 8.34059 7.11717 8.61544C7.11088 8.75286 7.09351 8.89118 7.07049 8.97591C7.06927 8.9804 7.06871 8.97882 7.06742 8.9828C6.96931 8.91428 6.74309 8.67553 6.43143 8.16083C6.14332 7.6847 5.87349 6.82837 5.87349 6.82837L5.86737 6.80924L5.86048 6.79087C5.86048 6.79087 5.81017 6.59957 5.58802 6.4434C5.3798 6.29682 5.18162 6.27656 5.18162 6.27656L5.14565 6.26967ZM5.05458 7.05338C5.07699 7.06157 5.12385 7.07846 5.13264 7.08246L5.12346 7.05491L5.1357 7.08323L5.13723 7.08399V7.08476H5.138C5.11831 7.07098 5.135 7.08466 5.13723 7.08782C5.14806 7.12474 5.38733 7.94893 5.76099 8.56646C6.10138 9.12862 6.35287 9.44356 6.62735 9.63181C6.90158 9.81988 7.27032 9.8005 7.45775 9.70299C7.70823 9.5729 7.77825 9.3591 7.82664 9.18103C7.87503 9.00295 7.8923 8.82228 7.90011 8.65141C7.91503 8.32539 7.88952 8.05869 7.8871 8.03225C7.8875 8.01752 7.89098 7.89015 7.87103 7.71846C7.85092 7.54546 7.81486 7.33048 7.66133 7.11461C7.83331 7.08905 7.92879 7.05014 8.2759 7.05338C8.71855 7.05754 8.78589 7.07601 8.96011 7.11614C9.05499 7.13802 9.06553 7.15614 9.05654 7.14675C9.04756 7.13735 9.05576 7.13108 9.06649 7.20721C9.08797 7.35945 9.06343 7.74989 9.06343 8.34221C9.06343 8.50918 9.04731 8.74464 9.07491 8.99122C9.10249 9.23765 9.17951 9.55296 9.47748 9.73743C9.64726 9.8425 9.97158 9.87864 10.2773 9.70835C10.5829 9.53805 10.8966 9.21138 11.2829 8.58406C11.6645 7.96554 11.8927 7.15235 11.9174 7.06639C11.9174 7.06639 11.9217 7.06356 11.9243 7.0618C11.9312 7.06213 11.9224 7.06333 11.9335 7.06333C12.0786 7.06333 13.317 7.05338 13.582 7.05338C13.6549 7.05338 13.6869 7.0573 13.7412 7.0595C13.7193 7.1441 13.6898 7.24262 13.6356 7.36946C13.5082 7.66759 13.2897 8.05426 12.9736 8.45701C12.7011 8.80399 12.4895 9.05565 12.3276 9.26598C12.1658 9.4763 12.0386 9.6422 11.9855 9.88208C11.9324 10.122 12.0337 10.3925 12.1722 10.564C12.3108 10.7355 12.4822 10.8799 12.711 11.0829C13.5732 11.8483 13.7146 12.0799 13.7282 12.1016V12.1023C13.7427 12.1254 13.7333 12.1022 13.7389 12.1138C13.69 12.1291 13.6318 12.1463 13.6264 12.1475H12.0406H12.0383C12.0383 12.1475 11.7466 12.1379 11.5301 11.9944L11.5294 11.9937H11.5286C11.2995 11.8436 11.0227 11.5863 10.738 11.3653C10.5956 11.2548 10.4507 11.1512 10.2826 11.0752C10.1145 10.9992 9.90147 10.9454 9.67723 11.0125C9.35268 11.1096 9.17256 11.4185 9.11471 11.6638C9.07318 11.8399 9.07932 11.993 9.07797 12.1467C9.0668 12.1473 9.07647 12.1475 9.06343 12.1475H8.55907C7.76262 12.1475 6.93405 11.9044 6.04034 10.9704C4.87842 9.75704 3.84176 7.41059 3.68615 7.05414L5.05458 7.05338ZM11.8898 7.05644C11.8827 7.05802 11.9031 7.05956 11.9197 7.06103C11.9174 7.06225 11.9199 7.05995 11.9166 7.0618C11.9163 7.05525 11.8994 7.05431 11.8898 7.05644Z"
                          fill="#252525"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
                <div id="wd-6628d842d090d" className="whb-mehpyg5om2c98m6fa6g8 wd-button-wrapper text-center">
                  <a className="btn btn-color-default btn-style-default btn-style-rectangle btn-size-default btn-qr btn-icon-pos-left">
                    <span className="wd-btn-icon">
                      <img
                        width="83"
                        height="82"
                        src="https://www.fotopostapp.ru/wp-content/uploads/2024/02/qr-x2.png"
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                      />
                    </span>
                  </a>
                </div>
              </div>
              <div className="whb-column whb-col-right whb-visible-lg" style={{ marginTop: '-4px' }}>
                <div id="wd-6628d842d0a7f" className="  whb-rqq3v0ztt9crxvwv1w9w wd-button-wrapper text-center">
                  <a
                    href="https://apps.apple.com/us/app/фотопочта-фото-и-фотокнига/id864842646"
                    title=""
                    className="btn btn-color-default btn-style-default btn-style-rectangle btn-size-default btn-apps btn-icon-pos-left"
                  >
                    <span className="wd-btn-icon">
                      <img
                        width="72"
                        height="24"
                        src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/appsm.png"
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                      />
                    </span>
                  </a>
                </div>
                <div id="wd-6628d842d0b10" className="whb-aac8w270sgijygxhrspz wd-button-wrapper text-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.tartugo.FotoPostAppRus"
                    title=""
                    className="btn btn-color-default btn-style-default btn-style-rectangle btn-size-default btn-apps btn-icon-pos-left"
                  >
                    <span className="wd-btn-icon">
                      <img
                        width="72"
                        height="24"
                        src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/gpsm.png"
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                      />
                    </span>
                  </a>
                </div>
                <div id="wd-6628d842d0b93" className="  whb-wrqp7t90zp0x62a94xhc wd-button-wrapper text-center">
                  <a
                    href="https://appgallery.huawei.com/app/C102709057"
                    title=""
                    className="btn btn-color-default btn-style-default btn-style-rectangle btn-size-default btn-apps btn-icon-pos-left"
                  >
                    <span className="wd-btn-icon">
                      <img
                        width="72"
                        height="24"
                        src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/apgalsm.png"
                        className="attachment-full size-full"
                        alt=""
                        decoding="async"
                      />
                    </span>
                  </a>
                </div>
              </div>
              <div className="whb-column whb-mobile-left whb-hidden-lg">
                <div className="site-logo">
                  <a href="https://www.fotopostapp.ru/" className="wd-logo wd-main-logo">
                    <img
                      src="https://www.fotopostapp.ru/wp-content/uploads/2024/04/logo.png"
                      alt="FotoPostApp"
                      style={{ maxWidth: '65px' }}
                    />
                  </a>
                </div>
              </div>
              <div className="whb-column whb-mobile-right whb-hidden-lg">
                <div
                  className="wd-tools-element wd-header-mobile-nav wd-style-text wd-design-1 whb-wn5z894j1g5n0yp3eeuz"
                  style={{ position: 'relative' }}
                >
                  <Link to={ROUTES.BASKET} className="basket" onClick={onBasketClick}>
                    {!!basket.length && <div>{basket.length}</div>}
                  </Link>
                  <a href="#" rel="nofollow" aria-label="Open mobile menu" onClick={onToggleMobileMenu}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
                      <path d="M 6 9 A 2.0002 2.0002 0 1 0 6 13 L 42 13 A 2.0002 2.0002 0 1 0 42 9 L 6 9 z M 6 22 A 2.0002 2.0002 0 1 0 6 26 L 42 26 A 2.0002 2.0002 0 1 0 42 22 L 6 22 z M 6 35 A 2.0002 2.0002 0 1 0 6 39 L 42 39 A 2.0002 2.0002 0 1 0 42 35 L 6 35 z" />
                    </svg>

                    <span className="wd-tools-text">Меню</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="whb-row whb-header-bottom whb-sticky-row whb-without-bg whb-without-border whb-color-dark whb-hidden-mobile whb-flex-flex-middle">
          <div className="container">
            <div className="whb-flex-row whb-header-bottom-inner">
              <div className="whb-column whb-col-left whb-visible-lg">
                <div
                  className="wd-header-nav wd-header-main-nav text-center wd-design-1"
                  role="navigation"
                  aria-label="Main navigation"
                >
                  <ul id="menu-category-1" className="menu wd-nav wd-nav-main wd-style-underline">
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-872 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to={ROUTES.FOTO} className="woodmart-nav-link">
                        <span className="nav-link-text">Фотографии</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-873 item-level-1 wd-event-hover">
                              <Link to="/products/photos/photos" className="woodmart-nav-link">
                                Классические фото
                              </Link>
                              <ul className="sub-sub-menu wd-dropdown">
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-907 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=10x10" className="woodmart-nav-link">
                                    10х10
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-906 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=10x15" className="woodmart-nav-link">
                                    10х15
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-905 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=13x15" className="woodmart-nav-link">
                                    13х18
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-904 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=15x15" className="woodmart-nav-link">
                                    15х15
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-903 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=15x20" className="woodmart-nav-link">
                                    15х20
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-902 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=20x20" className="woodmart-nav-link">
                                    20х20
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-901 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=20x30" className="woodmart-nav-link">
                                    20х30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-900 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=30x30" className="woodmart-nav-link">
                                    30х30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-899 item-level-2 wd-event-hover">
                                  <Link to="/products/photos/photos?size=30x40" className="woodmart-nav-link">
                                    30х40
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-957 item-level-1 wd-event-hover">
                              <Link to="/products/photos/fotoghrafii-v-ramkie" className="woodmart-nav-link">
                                Фото в рамке
                              </Link>
                              <ul className="sub-sub-menu wd-dropdown">
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-956 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=10x10"
                                    className="woodmart-nav-link"
                                  >
                                    10х10
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-955 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=10x15"
                                    className="woodmart-nav-link"
                                  >
                                    10×15
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-954 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=13x18"
                                    className="woodmart-nav-link"
                                  >
                                    13×18
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-953 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=15x15"
                                    className="woodmart-nav-link"
                                  >
                                    15×15
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-952 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=15x20"
                                    className="woodmart-nav-link"
                                  >
                                    15×20
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-951 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=20x20"
                                    className="woodmart-nav-link"
                                  >
                                    20×20
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-950 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=20x30"
                                    className="woodmart-nav-link"
                                  >
                                    20×30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-949 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=30x30"
                                    className="woodmart-nav-link"
                                  >
                                    30×30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-948 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/photos/fotoghrafii-v-ramkie?size=30x40"
                                    className="woodmart-nav-link"
                                  >
                                    30×40
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-946 item-level-1 wd-event-hover">
                              <Link to="/products/photos/photo-strip-RU" className="woodmart-nav-link">
                                Полоски из ФотоБудки
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-977 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/fotobooks" className="woodmart-nav-link">
                        <span className="nav-link-text">ФотоКниги</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-976 item-level-1 wd-event-hover">
                              <Link to="/products/fotobooks/photo-book-RU" className="woodmart-nav-link">
                                ФотоКниги «Премиум»
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-975 item-level-1 wd-event-hover">
                              <Link to="/products/fotobooks/photo-book-RU-slim" className="woodmart-nav-link">
                                ФотоКниги «Слим»
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-974 item-level-1 wd-event-hover">
                              <Link to="/products/fotobooks/photo-book-RU-light" className="woodmart-nav-link">
                                ФотоКниги «Лайт»
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-973 item-level-1 wd-event-hover">
                              <Link to="/products/fotobooks/photo-book-RU-soft" className="woodmart-nav-link">
                                ФотоКниги «Софт»
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-972 item-level-1 wd-event-hover">
                              <Link to="/products/fotobooks/notebook-RU" className="woodmart-nav-link">
                                Блокноты
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-992 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/calendars" className="woodmart-nav-link">
                        <span className="nav-link-text">Календари</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-991 item-level-1 wd-event-hover">
                              <Link to="/products/calendars/calendar-RU-magnet" className="woodmart-nav-link">
                                Календари магнитные
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-990 item-level-1 wd-event-hover">
                              <Link to="/products/calendars/calendar-RU-table" className="woodmart-nav-link">
                                Календари настольные
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-989 item-level-1 wd-event-hover">
                              <Link to="/products/calendars/calendar-RU" className="woodmart-nav-link">
                                Календари настенные
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1001 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/postcards" className="woodmart-nav-link">
                        <span className="nav-link-text">Открытки</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1000 item-level-1 wd-event-hover">
                              <Link
                                to="/products/postcards/postcards-product-self-sending"
                                className="woodmart-nav-link"
                              >
                                Отправлю самостоятельно
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-999 item-level-1 wd-event-hover">
                              <Link
                                to="/products/postcards/postcards-product-send-for-me"
                                className="woodmart-nav-link"
                              >
                                Отправьте за меня
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1046 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/decor" className="woodmart-nav-link">
                        <span className="nav-link-text">Декор Интерьера</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1045 item-level-1 wd-event-hover">
                              <Link to="/products/decor/canvas-dream-art" className="woodmart-nav-link">
                                Потреты Dream Art
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1044 item-level-1 wd-event-hover">
                              <Link to="/products/decor/portrait-on-canvas" className="woodmart-nav-link">
                                Портреты по фото акрилом
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1043 item-level-1 wd-event-hover">
                              <Link to="/products/decor/photo-mosaic" className="woodmart-nav-link">
                                ФотоМозаика
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1042 item-level-1 wd-event-hover">
                              <Link to="/products/decor/piechat-na-kholstie" className="woodmart-nav-link">
                                Холсты
                              </Link>
                              <ul className="sub-sub-menu wd-dropdown">
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1041 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=20x20"
                                    className="woodmart-nav-link"
                                  >
                                    20х20
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1040 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=20x30"
                                    className="woodmart-nav-link"
                                  >
                                    20х30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1039 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=30x30"
                                    className="woodmart-nav-link"
                                  >
                                    30х30
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1038 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=30x40"
                                    className="woodmart-nav-link"
                                  >
                                    30х40
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1037 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=20x45"
                                    className="woodmart-nav-link"
                                  >
                                    20х45
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1036 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=30x60"
                                    className="woodmart-nav-link"
                                  >
                                    30х60
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1035 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=30x90"
                                    className="woodmart-nav-link"
                                  >
                                    30х90
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1034 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=40x40"
                                    className="woodmart-nav-link"
                                  >
                                    40х40
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1033 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=40x60"
                                    className="woodmart-nav-link"
                                  >
                                    40х60
                                  </Link>
                                </li>
                                <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1032 item-level-2 wd-event-hover">
                                  <Link
                                    to="/products/decor/piechat-na-kholstie?size=50x70"
                                    className="woodmart-nav-link"
                                  >
                                    50х70
                                  </Link>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1086 item-level-1 wd-event-hover">
                              <Link to="/products/decor/photo-foam-board" className="woodmart-nav-link">
                                Пенокартон
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1085 item-level-1 wd-event-hover">
                              <Link to="/products/decor/module" className="woodmart-nav-link">
                                Модульные картины
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1084 item-level-1 wd-event-hover">
                              <Link to="/products/decor/photo-poster-RU" className="woodmart-nav-link">
                                Фотопостеры
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1083 item-level-1 wd-event-hover">
                              <Link to="/products/decor/photo-pillow-RU" className="woodmart-nav-link">
                                ФотоПодушки
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1082 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/souvenirs" className="woodmart-nav-link">
                        <span className="nav-link-text">Фотоcувениры</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1081 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/photo-badge" className="woodmart-nav-link">
                                Значки
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1080 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/kovrik-dlia-myshi" className="woodmart-nav-link">
                                Коврик для мыши
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1079 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/kruzhki" className="woodmart-nav-link">
                                Кружки
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1078 item-level-1 wd-event-hover">
                              <Link to="/products/gifts/ny_products" className="woodmart-nav-link">
                                Новогодние шары
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1077 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/fotopazly-kartonnyie" className="woodmart-nav-link">
                                Пазл картонный
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1076 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/tarielka-s-fotoghrafiiei" className="woodmart-nav-link">
                                Тарелки
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1075 item-level-1 wd-event-hover">
                              <Link to="/products/magnets/fotomaghnity" className="woodmart-nav-link">
                                Магниты
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1074 item-level-1 wd-event-hover">
                              <Link to="/products/souvenirs/fotopazly-maghnitnyie" className="woodmart-nav-link">
                                Пазлы магнитные
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1098 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/clothes" className="woodmart-nav-link">
                        <span className="nav-link-text">Одежда с Фото</span>
                      </Link>
                      <div className="color-scheme-dark wd-design-default wd-dropdown-menu wd-dropdown">
                        <div className="container">
                          <ul className="wd-sub-menu color-scheme-dark">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1097 item-level-1 wd-event-hover">
                              <Link to="/products/clothes/futbolki-dlia-dietiei" className="woodmart-nav-link">
                                Футболки детские
                              </Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1096 item-level-1 wd-event-hover">
                              <Link to="/products/clothes/futbolki-dlia-vzroslykh" className="woodmart-nav-link">
                                Футболки для взрослых
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1095 item-level-0 menu-simple-dropdown wd-event-hover">
                      <Link to="/products/certificates" className="woodmart-nav-link">
                        <span className="nav-link-text">Подарочные сертификаты</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openMenu && <div role="none" className="close-mobile-menu" onClick={onToggleMobileMenu} />}
      {openMenu && (
        <div className="mobile-nav wd-side-hidden wd-left wd-opener-arrow wd-opened">
          <ul className="wd-nav wd-nav-mob-tab wd-style-underline">
            <li
              className={`mobile-tab-title ${!mobileMenuTab ? ' active' : ''}`}
              onClick={() => setMobileMenuTab(0)}
              role="none"
            >
              Каталог
            </li>
            <li
              className={`mobile-tab-title ${mobileMenuTab ? ' active' : ''}`}
              onClick={() => setMobileMenuTab(1)}
              role="none"
            >
              Информация
            </li>
          </ul>
          {!mobileMenuTab && (
            <ul className="mobile-pages-menu menu wd-nav wd-nav-mobile wd-layout-dropdown">
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-872 item-level-0 opener-page">
                <Link to="/products/photos" className="woodmart-nav-link">
                  <span className="nav-link-text">Фотографии</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-873 item-level-1 opener-page">
                    <Link to="/products/photos/photos" className="woodmart-nav-link">
                      Классические фото
                    </Link>
                    <ul className="sub-sub-menu">
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-907 item-level-2">
                        <Link to="/products/photos/photos?size=10x10" className="woodmart-nav-link">
                          10х10
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-906 item-level-2">
                        <Link to="/products/photos/photos?size=10x15" className="woodmart-nav-link">
                          10х15
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-905 item-level-2">
                        <Link to="/products/photos/photos?size=13x15" className="woodmart-nav-link">
                          13х18
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-904 item-level-2">
                        <Link to="/products/photos/photos?size=15x15" className="woodmart-nav-link">
                          15х15
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-903 item-level-2">
                        <Link to="/products/photos/photos?size=15x20" className="woodmart-nav-link">
                          15х20
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-902 item-level-2">
                        <Link to="/products/photos/photos?size=20x20" className="woodmart-nav-link">
                          20х20
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-901 item-level-2">
                        <Link to="/products/photos/photos?size=20x30" className="woodmart-nav-link">
                          20х30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-900 item-level-2">
                        <Link to="/products/photos/photos?size=30x30" className="woodmart-nav-link">
                          30х30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-899 item-level-2">
                        <Link to="/products/photos/photos?size=30x40" className="woodmart-nav-link">
                          30х40
                        </Link>
                      </li>
                    </ul>
                    <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                      <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                        <path
                          d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                        />
                      </svg>
                    </span>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-957 item-level-1">
                    <Link to="/products/photos/fotoghrafii-v-ramkie" className="woodmart-nav-link">
                      Фото в рамке
                    </Link>
                    <ul className="sub-sub-menu">
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-956 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=10x10" className="woodmart-nav-link">
                          10х10
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-955 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=10x15" className="woodmart-nav-link">
                          10×15
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-954 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=13x18" className="woodmart-nav-link">
                          13×18
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-953 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=15x15" className="woodmart-nav-link">
                          15×15
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-952 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=15x20" className="woodmart-nav-link">
                          15×20
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-951 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=20x20" className="woodmart-nav-link">
                          20×20
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-950 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=20x30" className="woodmart-nav-link">
                          20×30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-949 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=30x30" className="woodmart-nav-link">
                          30×30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-948 item-level-2">
                        <Link to="/products/photos/fotoghrafii-v-ramkie?size=30x40" className="woodmart-nav-link">
                          30×40
                        </Link>
                      </li>
                    </ul>
                    <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                      <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                        <path
                          d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                        />
                      </svg>
                    </span>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-946 item-level-1">
                    <Link to="/products/photos/photo-strip-RU" className="woodmart-nav-link">
                      Полоски из ФотоБудки
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children menu-item-977 item-level-0">
                <Link to="/products/fotobooks" className="woodmart-nav-link">
                  <span className="nav-link-text">ФотоКниги</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-976 item-level-1">
                    <Link to="/products/fotobooks/photo-book-RU" className="woodmart-nav-link">
                      ФотоКниги «Премиум»
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-975 item-level-1">
                    <Link to="/products/fotobooks/photo-book-RU-slim" className="woodmart-nav-link">
                      ФотоКниги «Слим»
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-974 item-level-1">
                    <Link to="/products/fotobooks/photo-book-RU-light" className="woodmart-nav-link">
                      ФотоКниги «Лайт»
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-973 item-level-1">
                    <Link to="/products/fotobooks/photo-book-RU-soft" className="woodmart-nav-link">
                      ФотоКниги «Софт»
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-972 item-level-1">
                    <Link to="/products/fotobooks/notebook-RU" className="woodmart-nav-link">
                      Блокноты
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-992 item-level-0">
                <Link to="/products/calendars" className="woodmart-nav-link">
                  <span className="nav-link-text">Календари</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-991 item-level-1">
                    <Link to="/products/calendars/calendar-RU-magnet" className="woodmart-nav-link">
                      Календари магнитные
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-990 item-level-1">
                    <Link to="/products/calendars/calendar-RU-table" className="woodmart-nav-link">
                      Календари настольные
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-989 item-level-1">
                    <Link to="/products/calendars/calendar-RU" className="woodmart-nav-link">
                      Календари настенные
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1001 item-level-0">
                <Link to="/products/postcards" className="woodmart-nav-link">
                  <span className="nav-link-text">Открытки</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1000 item-level-1">
                    <Link to="/products/postcards/postcards-product-self-sending" className="woodmart-nav-link">
                      Отправлю самостоятельно
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-999 item-level-1">
                    <Link to="/products/postcards/postcards-product-send-for-me" className="woodmart-nav-link">
                      Отправьте за меня
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1046 item-level-0">
                <Link to="/products/decor" className="woodmart-nav-link">
                  <span className="nav-link-text">Декор Интерьера</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1045 item-level-1">
                    <Link to="/products/decor/canvas-dream-art" className="woodmart-nav-link">
                      Потреты Dream Art
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1044 item-level-1">
                    <Link to="/products/decor/portrait-on-canvas" className="woodmart-nav-link">
                      Портреты по фото акрилом
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1043 item-level-1">
                    <Link to="/products/decor/photo-mosaic" className="woodmart-nav-link">
                      ФотоМозаика
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1042 item-level-1">
                    <Link to="/products/decor/piechat-na-kholstie" className="woodmart-nav-link">
                      Холсты
                    </Link>
                    <ul className="sub-sub-menu">
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1041 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=20x20" className="woodmart-nav-link">
                          20х20
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1040 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=20x30" className="woodmart-nav-link">
                          20х30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1039 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=30x30" className="woodmart-nav-link">
                          30х30
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1038 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=30x40" className="woodmart-nav-link">
                          30х40
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1037 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=20x45" className="woodmart-nav-link">
                          20х45
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1036 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=30x60" className="woodmart-nav-link">
                          30х60
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1035 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=30x90" className="woodmart-nav-link">
                          30х90
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1034 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=40x40" className="woodmart-nav-link">
                          40х40
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1033 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=40x60" className="woodmart-nav-link">
                          40х60
                        </Link>
                      </li>
                      <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1032 item-level-2">
                        <Link to="/products/decor/piechat-na-kholstie?sixe=50x70" className="woodmart-nav-link">
                          50х70
                        </Link>
                      </li>
                    </ul>
                    <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                      <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                        <path
                          d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                        />
                      </svg>
                    </span>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1086 item-level-1">
                    <a
                      href="https://www.fotopostapp.ru/product/dekor-interera-pechat-na-penokartone/"
                      className="woodmart-nav-link"
                    >
                      Пенокартон
                    </a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1085 item-level-1">
                    <a
                      href="https://www.fotopostapp.ru/product/dekor-interera-modulnye-kartiny/"
                      className="woodmart-nav-link"
                    >
                      Модульные картины
                    </a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1084 item-level-1">
                    <a
                      href="https://www.fotopostapp.ru/product/dekor-interera-fotopostery/"
                      className="woodmart-nav-link"
                    >
                      Фотопостеры
                    </a>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1083 item-level-1">
                    <a
                      href="https://www.fotopostapp.ru/product/dekor-interera-fotopodushki/"
                      className="woodmart-nav-link"
                    >
                      ФотоПодушки
                    </a>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1082 item-level-0">
                <Link to="/products/souvenirs" className="woodmart-nav-link">
                  <span className="nav-link-text">Фотоcувениры</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1081 item-level-1">
                    <Link to="/products/souvenirs/photo-badge" className="woodmart-nav-link">
                      Значки
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1080 item-level-1">
                    <Link to="/products/souvenirs/kovrik-dlia-myshi" className="woodmart-nav-link">
                      Коврик для мыши
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1079 item-level-1">
                    <Link to="/products/souvenirs/kruzhki" className="woodmart-nav-link">
                      Кружки
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1078 item-level-1">
                    <Link to="/products/gifts/ny_products" className="woodmart-nav-link">
                      Новогодние шары
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1077 item-level-1">
                    <Link to="/products/souvenirs/fotopazly-kartonnyie" className="woodmart-nav-link">
                      Пазл картонный
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1076 item-level-1">
                    <Link to="/products/souvenirs/tarielka-s-fotoghrafiiei" className="woodmart-nav-link">
                      Тарелки
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1075 item-level-1">
                    <Link to="/products/magnets/fotomaghnity" className="woodmart-nav-link">
                      Магниты
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1074 item-level-1">
                    <Link to="/products/magnets/fotopazly-maghnitnyie" className="woodmart-nav-link">
                      Пазлы магнитные
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-1098 item-level-0">
                <Link to="/products/clothes" className="woodmart-nav-link">
                  <span className="nav-link-text">Одежда с Фото</span>
                </Link>
                <ul className="wd-sub-menu">
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1097 item-level-1">
                    <Link to="/products/clothes/futbolki-dlia-dietiei" className="woodmart-nav-link">
                      Футболки детские
                    </Link>
                  </li>
                  <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1096 item-level-1">
                    <Link to="/products/clothes/futbolki-dlia-vzroslykh" className="woodmart-nav-link">
                      Футболки для взрослых
                    </Link>
                  </li>
                </ul>
                <span className="wd-nav-opener" onClick={onOpenSubmenu} role="none">
                  <svg fill="currentColor" height="12px" width="12px" viewBox="0 0 330 330">
                    <path
                      d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001
	c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213
	C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606
	C255,161.018,253.42,157.202,250.606,154.389z"
                    />
                  </svg>
                </span>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1095 item-level-0">
                <Link to="/products/certificates" className="woodmart-nav-link">
                  <span className="nav-link-text">Подарочные сертификаты</span>
                </Link>
              </li>
            </ul>
          )}
          {!!mobileMenuTab && (
            <ul className="mobile-categories-menu menu wd-nav wd-nav-mobile wd-layout-dropdown">
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-281 item-level-0">
                <a href="https://www.fotopostapp.ru/o-fotopochte/" className="woodmart-nav-link">
                  <span className="nav-link-text">О ФотоПочте</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-276 item-level-0">
                <a href="https://www.fotopostapp.ru/akczii/" className="woodmart-nav-link">
                  <span className="nav-link-text">Акции</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-280 item-level-0">
                <a href="https://www.fotopostapp.ru/sdelaem-za-vas/" className="woodmart-nav-link">
                  <span className="nav-link-text">Сделаем за вас</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-282 item-level-0">
                <a href="https://www.fotopostapp.ru/biznesu/" className="woodmart-nav-link">
                  <span className="nav-link-text">Бизнесу</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-762 item-level-0">
                <a href="https://www.fotopostapp.ru/reviews/" className="woodmart-nav-link">
                  <span className="nav-link-text">Отзывы</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-279 item-level-0">
                <a href="https://www.fotopostapp.ru/faq/" className="woodmart-nav-link">
                  <span className="nav-link-text">FAQ</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-278 item-level-0">
                <a href="https://www.fotopostapp.ru/franshiza/" className="woodmart-nav-link">
                  <span className="nav-link-text">Франшиза</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-277 item-level-0">
                <a href="https://www.fotopostapp.ru/podderzhka-i-kontakty/" className="woodmart-nav-link">
                  <span className="nav-link-text">Поддержка и контакты</span>
                </a>
              </li>
              <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1279 item-level-0">
                <a href="https://www.fotopostapp.ru/delivery/" className="woodmart-nav-link">
                  <span className="nav-link-text">Доставка</span>
                </a>
              </li>
            </ul>
          )}
        </div>
      )}
    </header>
  );
};
